import { render, staticRenderFns } from "./InfoGraphicBoxReadOnly.vue?vue&type=template&id=c6188248&"
import script from "./InfoGraphicBoxReadOnly.vue?vue&type=script&lang=js&"
export * from "./InfoGraphicBoxReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./InfoGraphicBoxReadOnly.vue?vue&type=style&index=0&id=c6188248&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports